import { defineMessages } from 'react-intl';

export default defineMessages({
  cookieBannerTitle: {
    id: 'app.components.app.newCookieBanner.cookieBannerTitle',
    defaultMessage: 'Manage your cookie settings',
  },
  mandatoryCookiesTitle: {
    id: 'app.components.app.newCookieBanner.mandatoryCookiesTitle',
    defaultMessage: 'Mandatory Cookies',
  },
  mandatoryCookiesParagraph: {
    id: 'app.components.app.newCookieBanner.mandatoryCookiesParagraph',
    defaultMessage:
      'Functional cookies are needed for the proper functionning of the website and can not be refused. For more informations read cookie policy.',
  },
  optionalCookiesTitle: {
    id: 'app.components.app.newCookieBanner.optionalCookiesTitle',
    defaultMessage: 'Cookie to improve your experience',
  },
  analyticsCookies: {
    id: 'app.components.app.newCookieBanner.optionalCookiesTitle',
    defaultMessage: 'Analytics',
  },
  more: {
    id: 'app.components.app.newCookieBanner.more.button',
    defaultMessage: 'More',
  },
  continue: {
    id: 'app.components.app.newCookieBanner.continue.button',
    defaultMessage: 'Continue',
  },
});
